import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getCartState, getCurrentCartState, hasProductsWithInvalidPrice } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, CreateAdyenConfiguration, SetOnSubmit, SetPaymentMethodsConfig } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/LoadAdyenDropInConfiguration";
// Poolcorp Custom Code - Swapped to the overriden payment service
import { getAdyenPaymentDetails, postAdyenPayment } from "@store/Services/PaymentService";

replaceInChain(chain, SetOnSubmit, props => {
    /* Poolcorp Custom Code */
    const handleValidPaymentResponse = (
        resultCode: string, 
        pspReference: string, 
        recurringDetailReference: string, 
        cardType: string, 
        cardSummary: string,
        cardSchemeEnhancedDataLevel: string,
        avsResult: string,
        cardBin: string,
        cardExpirationDate: string,
    ) => {
        (props.parameter as any).placeAdyenOrder(resultCode, pspReference, recurringDetailReference, cardType, cardSummary, cardSchemeEnhancedDataLevel, avsResult, cardBin, cardExpirationDate);
    };
    /* Poolcorp Custom Code */

    const handleInvalidPaymentResponse = (errorMessage: string) => {
        props.parameter.setAdyenErrorMessage(errorMessage);
        props.parameter.resetAdyenSession();
    };

    const handleRedirectPaymentAction = (adyenPaymentResult: any) => {
        if (adyenPaymentResult.action.method === "GET") {
            window.location.href = adyenPaymentResult.action.url;
        } else if (adyenPaymentResult.action.method === "POST") {
            const form = document.createElement("form");
            form.method = "POST";
            form.action = adyenPaymentResult.action.url;

            for (const key in adyenPaymentResult.action.data) {
                const input = document.createElement("input");
                input.name = key;
                input.value = adyenPaymentResult.action.data[key];
                form.appendChild(input);
            }

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
        }
    };

    const handlePaymentResponse = (result: any) => {
        if (result?.action) {
            if (result.action.type === "redirect") {
                handleRedirectPaymentAction(result);
            } else {
                handleInvalidPaymentResponse("Adyen_Error");
            }
        } else {
            switch (result?.resultCode) {
                case "Pending":
                case "Received":
                case "Authorised":
                    /* Poolcorp Custom Code */
                    handleValidPaymentResponse(
                        result.resultCode, 
                        result.pspReference, 
                        result.additionalData["recurring.recurringDetailReference"], 
                        result.additionalData?.paymentMethod, 
                        result.additionalData?.cardSummary,
                        result.additionalData?.cardSchemeEnhancedDataLevel,
                        result.additionalData?.avsResult,
                        result.additionalData?.cardBin,
                        result.additionalData?.expiryDate,
                    );   
                    /* Poolcorp Custom Code */
                    break;
                case "Refused":
                    handleInvalidPaymentResponse("Adyen_Refused");
                    break;
                case "Cancelled":
                    if (result?.additionalData?.avsResultRaw === "2") {
                        handleInvalidPaymentResponse("Adyen_CancelledAvsCode2");
                    }
                    else {
                        handleInvalidPaymentResponse("Adyen_Cancelled");
                    }

                    break;
                default:
                    handleInvalidPaymentResponse("Adyen_Error");
                    break;
            }
        }
    };

    props.adyenConfiguration.onSubmit = (state: any, component: any) => {
        const cartState = props.parameter.cartId
            ? getCartState(props.getState(), props.parameter.cartId)
            : getCurrentCartState(props.getState());

        if (hasProductsWithInvalidPrice(cartState.value)) {
            handleInvalidPaymentResponse("ReviewAndPay_HasProductsWithInvalidPrice");
            return;
        }

        postAdyenPayment(
            props.parameter.webOrderNumber,
            cartState.value!.orderGrandTotal,
            props.getState().context.session.currency!.currencyCode,
            props.parameter.returnUrl,
            state.data,
        ).then(result => {
            handlePaymentResponse(result);
        });
    };

    props.adyenConfiguration.onAdditionalDetails = (state: any, component: any) => {
        getAdyenPaymentDetails(state.details.redirectResult).then(result => {
            handlePaymentResponse(result);
        });
    };

});

addToChainAfter(chain, SetPaymentMethodsConfig, props => {
    const parameter = props.parameter as any;

    // Enable card stored payment
    props.adyenConfiguration.paymentMethodsConfiguration.card.enableStoreDetails = parameter.enableStoredPaymentMethods;
    props.adyenConfiguration.paymentMethodsConfiguration.card.showStoredPaymentMethods = parameter.enableStoredPaymentMethods;

    // Enable ach stored payments (not yet supported in this version)
    props.adyenConfiguration.paymentMethodsConfiguration.ach = { enableStoreDetails: parameter.enableStoredPaymentMethods };

    // Activates AVS validation. "Partial mode" only adds a ZipCode field, which is enough for basic AVS validation.
    if (parameter.enableAddressValidationSystem) {
        props.adyenConfiguration.paymentMethodsConfiguration.card.billingAddressRequired = true;
        props.adyenConfiguration.paymentMethodsConfiguration.card.billingAddressMode = "partial";
    }

    // Used in AdyenDropIn.tsx
    props.adyenConfiguration = {
        ...props.adyenConfiguration,
        custom: {
            showStoredPaymentMethods: parameter.enableStoredPaymentMethods,
            showRemovePaymentMethodButton: parameter.enableRemoveStoredPaymentMethods
        }
    };
});